import { createContext } from 'react';

import { XAxisProps } from '../types/annotations-x-axis-props.js';

export const AnnotationsAxisConfigContext = createContext<
  XAxisProps | undefined
>(undefined);
